<template>
  <div>
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Báo giá', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bscantem" class="soft-control">
        <div class="d-block">
          <StreamBarcodeReader
            @decode="onDecode"
            @loaded="onLoaded"
          ></StreamBarcodeReader>
        </div>
        <div v-if="!isScanner">
          <h5 class="m-5 text-center">
            THIẾT BỊ CỦA BẠN KHÔNG HỖ TRỢ QUÉT TEM
          </h5>
        </div>
        <b-row align-h="center">
          <b-col md="4">
            <b-button class="mb-2" block="" variant="success" @click="doVerify">
              Xác nhận đã nhập kho
            </b-button>
          </b-col>
        </b-row>
        <div>
          <soft-table
            @rowSelected="tbSetRowSelected"
            @rowClicked="tbRowClicked"
            class="table align-items-center table-flush"
            tbody-classes="list"
            :pending="false"
            :dataTable="listTems"
            :fields="fields"
            :minHeight="$hControl - 150"
            ref="soft-table"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(quantity)="{ item }">
              {{ item.quantity }} {{ item.tem.manufature.unit }}
            </template>
            <template v-slot:cell(tem.manufature.product)="{ value, item }">
              <ul>
                <li>{{ value.name }}</li>
                <li>Quy cách: {{ item.tem.manufature.productSpecify.name }}</li>
                <li>Màu sắc : {{ item.tem.manufature.color.label }}</li>
              </ul>
            </template>
            <template v-slot:cell(userManage)="{ value }">
              <span v-if="value.id" class="badge badge-info">{{
                value.username
              }}</span>
              <span v-else class="badge badge-danger">
                Chưa có người hỗ trợ
              </span>
            </template>
          </soft-table>
        </div>
      </block>
    </div>
  </div>
</template>
<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import { temService } from "@/_services";
import { receiptService } from "@/_services";

const srcDone = require("@/assets/sound/done.wav");
export default {
  name: "scanner-tem-cp",
  components: {
    StreamBarcodeReader
  },
  data: () => ({
    loading: true,
    lastIndexCustomerSelected: 0,
    info: {},
    tableData: [],
    isScanner: false,
    fields: [
      {
        key: "index",
        label: "STT",
        sortable: true,
        class: "col-fix text-center"
      },
      {
        key: "code",
        label: "Mã Tem",
        sortable: true,
        class: "col-fix text-center"
      },
      {
        key: "quantity",
        label: "Số lượng",
        sortable: true,
        class: "col-fix text-center"
      },
      {
        key: "tem.manufature.product",
        label: "Sản phẩm",
        sortable: true,
        class: "col-fix text-left"
      },
      {
        key: "dateUpdated",
        label: "Lần cuối cập nhật",
        sortable: true,
        class: "col-fix text-center"
      }
    ],
    listResults: [],
    listTems: [],
    audio: {
      scanDone: new Audio(srcDone)
    }
  }),

  methods: {
    onDecode(result) {
      if (!this.listResults.includes(result)) {
        console.log("onDecode", result);
        temService.getTemScanner(result).then(res => {
          let tem = res.data;
          if (tem.type == "BAG") {
            if (!tem.active) {
              this.$alertify.error("Tem này đã bị hủy", {
                duration: 4000
              });
            } else if (tem.status >= 2) {
              this.$alertify.error("Tem này đã được nhập kho", {
                duration: 4000
              });
            } else {
              this.audio.scanDone.pause();
              this.audio.scanDone.play();
              this.listTems.unshift(tem);
              this.listResults.push(result);
              console.log("listTems", this.listTems);
            }
          } else {
            this.$alertify.warning("Hiện tại chỉ quét được tem bịch", {
              duration: 4000
            });
          }
        });
      } else {
        this.$alertify.warning(
          "Tem này đã quét rồi, mỗi tem chỉ được quét 1 lần thôi",
          {
            duration: 4000
          }
        );
      }
    },
    doVerify() {
      if (this.listTems.length == 0) {
        this.$alertify.warning("Chưa có tem nào để nhập", {
          duration: 4000
        });
      } else {
        this.$refs.bscantem.block();
        receiptService
          .verifyIn(this.listTems)
          .then(res => {
            this.$alertify.success(res.message, {
              duration: 4000
            });
            this.listTems = [];
            this.listResults = [];
          })
          .finally(() => {
            this.$refs.bscantem.unBlock();
          });
      }
    },
    onLoaded(result) {
      this.isScanner = true;
      console.log("onLoaded", result);
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    }
  }
};
</script>
<style lang="scss">
.scanner-container {
  video {
    height: 150px;
    margin: 0 auto;
    display: table;
    width: 100%;
    object-fit: cover;
  }
}
</style>
